import React from "react";
import { Col, Row } from "react-bootstrap";
import CKYCForm from "./CKYCForm";
import moment from "moment";
var CKYCFormpopup = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-0 mx-0 dpledger-block ckyc-popup" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: " HeadRow ckyc-popup-head" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.setpaymentlinkshow(false);
                            } }),
                        "CKYC Form"),
                    React.createElement("span", { className: "DMSanN_14_400 text-right" },
                        "Date: ",
                        moment(new Date()).format("DD-MM-YYYY HH:mm:ss A")))),
            React.createElement(Row, { className: "px-0 mx-0 payment-popuptable-block" },
                React.createElement(Row, { className: "mx-0 payment-generictabs-block" },
                    React.createElement(CKYCForm, { setckycFileUploadError: props.setckycFileUploadError, setckycSubmitSuccessFull: props.setckycSubmitSuccessFull, setCKYCUploadErrorChild: props.setCKYCUploadErrorChild }))))));
};
export default CKYCFormpopup;
